module.exports = "/_next/static/images/c37b42d45d7dbf34ed3deba0ee5d8105-tiger.png";